export const ActionLogType = {
    ConfirmCheckboxChecked: "ConfirmCheckboxChecked",
    PackageChanged: "PackageChanged",
    PackageSelected: "PackageSelected",
    ContractFinalized: "ContractFinalized"
}